// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1npBi","label":"Labeled_label__EE6jE","divider":"Labeled_divider__fdkmG"};